module.exports = __webpack_public_path__ + "img/icon-02.4d0d21fe.svg";